import React from 'react';
import { Modal } from 'antd';
import { t } from '../../../i18n/i18n';
import './ViewQuestionModal.scss';

export default function ViewQuestionModal({ visible, question, onClose }) {
  if (!question) return null;

  return (
    <Modal
      title={
        <div className="d-flex align-items-center">
          <span className="text-lg font-weight-600">
            {t('VIEW_QUESTION_TITLE')}
          </span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      className="view-question-modal"
    >
      <div className="view-question-content">
        {/* Tipo de pregunta */}
        <div className="mb-3">
          <label className="text-sm font-weight-600 text-muted d-block mb-1">
            {t('QUESTION_TYPE')}
          </label>
          <span className="badge badge-primary px-3 py-2">
            {t(`CREATE_SCREENING_YOUR_QUESTIONS_${question?.answerType}`)}
          </span>
        </div>

        {/* Texto de la pregunta */}
        <div className="mb-3">
          <label className="text-sm font-weight-600 text-muted d-block mb-1">
            {t('QUESTION_TEXT')}
          </label>
          <div className="question-text-box p-3 bg-light rounded">
            <p className="mb-0">{question?.text}</p>
          </div>
        </div>

        {/* Opciones (si es CHECK o RADIO) */}
        {(question?.answerType === 'CHECK' || question?.answerType === 'RADIO') &&
          question?.answerOptions &&
          question.answerOptions.length > 0 && (
            <div className="mb-3">
              <label className="text-sm font-weight-600 text-muted d-block mb-2">
                {t('ANSWER_OPTIONS')}
              </label>
              <ul className="list-unstyled">
                {question.answerOptions.map((option, index) => (
                  <li key={index} className="mb-2 d-flex align-items-start">
                    <span className="mr-2 text-primary font-weight-600">•</span>
                    <span>{option.text || option}</span>
                    {option.isCorrect && (
                      <span className="badge badge-success ml-2">
                        {t('CORRECT_ANSWER')}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

        {/* Dificultad */}
        {question?.questionDifficulty && (
          <div className="mb-3">
            <label className="text-sm font-weight-600 text-muted d-block mb-1">
              {t('DIFFICULTY')}
            </label>
            <span className="badge badge-info px-3 py-2">{question.questionDifficulty}</span>
          </div>
        )}

        {/* Tema */}
        {question?.theme && (
          <div className="mb-3">
            <label className="text-sm font-weight-600 text-muted d-block mb-1">
              {t('THEME')}
            </label>
            <span className="badge badge-secondary px-3 py-2">{question.theme}</span>
          </div>
        )}

        {/* Nota de solo lectura */}
        <div className="alert alert-info mt-4 d-flex align-items-center">
          <i className="fas fa-info-circle mr-2"></i>
          <span className="text-sm">
            {t('VIEW_QUESTION_READ_ONLY')}
          </span>
        </div>
      </div>
    </Modal>
  );
}
